/*
 * File: UISelect.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 09/19/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Wrapper for the material ui select field.  Used in form and filter selects
 */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FilledInput from "@material-ui/core/FilledInput";
import FormControl from "@material-ui/core/FormControl";
import PropTypes from "prop-types";
import { PropTypes as mobxProbTypes } from "mobx-react";

const useStyles = makeStyles({
  fullWidth: {
    width: "100%"
  }
});

const UISelect = ({
  options,
  label,
  value,
  parentOnChange,
  parentOnBlur,
  error,
  name,
  fullWidth,
  disabled
}) => {
  const classes = useStyles();

  let selectCSS = fullWidth ? classes.fullWidth : "";

  let optionMenuItems = options.map((option, idx) => {
    return (
      <MenuItem value={option.id} key={idx}>
        {option.name}
      </MenuItem>
    );
  });

  if (Number.isInteger(value)) {
    value = value.toString();
  }

  return (
    <FormControl className={selectCSS} variant="filled">
      <InputLabel htmlFor={label}>{label}</InputLabel>
      <Select
        value={value}
        onChange={parentOnChange}
        onBlur={parentOnBlur}
        error={error}
        label={label}
        name={name}
        displayEmpty
        input={<FilledInput name={label} id={label} />}
        disabled={disabled}
      >
        {optionMenuItems}
      </Select>
    </FormControl>
  );
};

UISelect.propTypes = {
  options: mobxProbTypes.observableArray.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  parentOnChange: PropTypes.func.isRequired,
  parentOnBlur: PropTypes.func,
  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

export default UISelect;
